module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/desktop/svg/membership_label_12-280837.svg";